import { connect } from 'react-redux'
import { replace } from 'react-router-redux'

import { fetchPin, updatePin } from '../../actions/pins'

import PinDetails from '../../components/pins/pin-details'

const tabNames = [
  'image',
  'history'
]

function mapStateToProps (state, ownProps) {
  const {
    params: { pinId },
    ...rest
  } = ownProps

  const selectedTab = tabNames.indexOf(ownProps.location.query.tab)

  const pin = state.pins[pinId]
  if (!pin) return { loading: true }

  const area = state.areas[pin.area]
  if (!area) return { loading: true }

  const latestHistory = state.pinHistories[pin.latestHistory]

  return {
    pin: {
      ...pin,
      isResolved: pin.status === 'resolved'
    },
    area,
    latestHistory,
    selectedTab,
    userForHistory (historyId) {
      return state.users[state.pinHistories[historyId].user]
    },
    ...rest
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(fetchPin(ownProps.params.pinId))

  return {
    markAsResolved () {
      dispatch(updatePin(ownProps.params.pinId, { status: 'resolved' }))
    },

    onTabSelect (tabIndex) {
      dispatch(replace({
        pathname: ownProps.location.pathname,
        query: { tab: tabNames[tabIndex] }
      }))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PinDetails)



// WEBPACK FOOTER //
// ./src/containers/pins/pin-details-container.js